"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FlagJE = function FlagJE(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "411.6",
    height: "270.36",
    viewBox: "0 0 411.6 270.36"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M209.54,146.36H-185.94A7.07,7.07,0,0,1-193,139.3V-114.94a7.06,7.06,0,0,1,7.06-7.06H209.54a7.06,7.06,0,0,1,7.06,7.06V139.3a7.06,7.06,0,0,1-7.06,7.06Zm0,0",
    transform: "translate(194.21 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M216.6-114.94a7.06,7.06,0,0,0-7.06-7.06H190.83L11.8-4.71-167.23-122h-18.71a7.06,7.06,0,0,0-7.06,7.06v9.83L-14,12.18-193,129.47v9.83a7.07,7.07,0,0,0,7.06,7.06h18.71L11.8,29.07l179,117.29h18.71a7.07,7.07,0,0,0,7.06-7.06v-9.83L37.57,12.18l179-117.29Zm0,0",
    transform: "translate(194.21 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M33.05-91.13s-2.24-3.36-5.59-1.12c0,0,3.88,2.8,1.25,5.73-2.77,3.11-6.59.07-6.82-2.16a2,2,0,0,0,1.82-1.95,2,2,0,0,0-2-2,2,2,0,0,0-2,2,2,2,0,0,0,1.29,1.84c-.48,1.91-5.48,3.36-6.92.21-1.62-3.55.95-6.57,4.4-6.15,0,0-.66-4.4-5.34-2.55,0,0,2-5-1.4-8.39-3.35,3.36-1.4,8.39-1.4,8.39-4.68-1.85-5.34,2.55-5.34,2.55,3.46-.42,6,2.59,4.4,6.15C8-85.43,3-86.88,2.54-88.79a2,2,0,0,0,1.3-1.84,2,2,0,0,0-2-2,2,2,0,0,0-2,2,2,2,0,0,0,1.82,1.95c-.23,2.23-4,5.27-6.82,2.16-2.62-2.93,1.26-5.73,1.26-5.73-3.36-2.24-5.59,1.12-5.59,1.12C-10.56-95.61-15-94.49-15-94.49c4.47,5.59,7.76,17.13,7.76,17.13H30.88s3.29-11.54,7.76-17.13c0,0-4.48-1.12-5.59,3.36Zm0,0",
    transform: "translate(194.21 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M30.87-77.36A57.23,57.23,0,0,0,11.8-80.62,57.23,57.23,0,0,0-7.27-77.36c-10,43.84,19.07,55.55,19.07,55.55S40.88-33.52,30.87-77.36Zm0,0",
    transform: "translate(194.21 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-2.15-61.77a2.3,2.3,0,0,0-1.72.47s-.28-1.1,1.16-1.37.56.9.56.9Zm0,0",
    transform: "translate(194.21 123)",
    fill: "#82afff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-3.25-63.16A2.27,2.27,0,0,0-5-63.56s.27-1.1,1.66-.66.07,1.06.07,1.06Zm0,0",
    transform: "translate(194.21 123)",
    fill: "#82afff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-2.66-62.59a2.68,2.68,0,0,0-1.87.47s-.3-1.11,1.26-1.37.61.9.61.9Zm0,0",
    transform: "translate(194.21 123)",
    fill: "#82afff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M14.7-59.66a2.27,2.27,0,0,0-1.56.85s-.53-1,.8-1.6.76.75.76.75Zm0,0",
    transform: "translate(194.21 123)",
    fill: "#82afff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M13.33-60.86a2.25,2.25,0,0,0-1.78,0s0-1.14,1.47-1,.31,1,.31,1Zm0,0",
    transform: "translate(194.21 123)",
    fill: "#82afff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M14-60.34a2.68,2.68,0,0,0-1.72.88s-.55-1,.91-1.62.81.74.81.74Zm0,0",
    transform: "translate(194.21 123)",
    fill: "#82afff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M25.34-59.09s-.34,0-1,.59c0,0-.44-1,.87-1.49s.1.9.1.9Zm0,0",
    transform: "translate(194.21 123)",
    fill: "#82afff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M24.68-60.46A2.18,2.18,0,0,0,23-60.55s.08-1.1,1.47-.9.24,1,.24,1Zm0,0",
    transform: "translate(194.21 123)",
    fill: "#82afff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M25.3-59.92a2.59,2.59,0,0,0-1.7.75s-.47-1,1-1.51.72.76.72.76Zm0,0",
    transform: "translate(194.21 123)",
    fill: "#82afff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-3.68-68.68a2.47,2.47,0,0,0-1.91-.27s.19-1.21,1.73-.87.18,1.14.18,1.14Zm0,0",
    transform: "translate(194.21 123)",
    fill: "#82afff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-3.75-70.78a2.27,2.27,0,0,0-1.71-.93A1.4,1.4,0,0,1-3.39-72c1.32.88-.36,1.2-.36,1.2Zm0,0",
    transform: "translate(194.21 123)",
    fill: "#82afff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-3.75-69.67a2.8,2.8,0,0,0-2.06-.41s.26-1.29,1.92-.81.14,1.22.14,1.22Zm0,0",
    transform: "translate(194.21 123)",
    fill: "#82afff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M22.66-65.83c1.47,0,3.22-.55,3.5-2.08.32-1.75-1.18-2.64-3.2-2.56-1.47.06-5.21.9-7.88.81s-2.71-2.71,1.29-2.43c5.94.41,6.88-.36,6.88-.36-3.19.6-4.46-.52-7.85-.52s-4,2.35-2.67,3.63c1.53,1.43,7.09.48,8.57.2s3.34-.29,3.49.74-2.33.88-4.09.81c-2.78-.1-6.84.66-10.44.84-3,.16-3.42-.69-4.11-1.56a2,2,0,0,0,.25-1,2.08,2.08,0,0,0-.07-.5,2.46,2.46,0,0,0,.58-1.3,2.54,2.54,0,0,0-1.35.16,2.86,2.86,0,0,0-1.77-.59A2.81,2.81,0,0,0,2-70.9a2.54,2.54,0,0,0-1.35-.16,2.55,2.55,0,0,0,.57,1.3,2.08,2.08,0,0,0-.07.5A2.09,2.09,0,0,0,2-67.66a1.31,1.31,0,0,1,.46.75l.09.42a.61.61,0,0,0,.31.42,5.64,5.64,0,0,1-4.25-2.67c-.68-1-1.1-3.14-2.14-3.38l-.61,3.26A9.59,9.59,0,0,0-.42-64.6a35.53,35.53,0,0,0,4.17,1.84c.1.47-1.7.77-3.54.4-1.28-.26-3-2.12-4-2l1.14,2.54a10.84,10.84,0,0,0,8.16,1.6,2.92,2.92,0,0,0,2.38-2.21c.68-.12,1.41-.26,3.68-.82a16.11,16.11,0,0,1,3.13-.41c.31.7,1,1.6,3.43,1.68,0,0,.58.93-1.41.75s-2.5-.81-3.67-.68l1,2.49A14.7,14.7,0,0,1,19.8-60a.88.88,0,0,0,.93-.35c.34-.5.18-.79-.14-1.25a5,5,0,0,1-.33-1.75c1.15.29,4.67-.43,5.94-.32a1.51,1.51,0,0,1,1.17,2.1c-.29.5-3,.07-3,.07L25.3-59a4.89,4.89,0,0,0,.95-.77c.56-.52,2.82-.34,2.82-.74v-4.54a.36.36,0,0,0-.4-.36c-5,.43-6-.4-6-.4Zm0,0",
    transform: "translate(194.21 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M2.74-67.45A1.36,1.36,0,0,1,2.9-67l.08.42a.29.29,0,0,0,.28.26H4.42a.31.31,0,0,0,.28-.26L4.77-67a1.94,1.94,0,0,1,.16-.48Zm0,0",
    transform: "translate(194.21 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M3.84-66.61c-.27,0-.48,0-.45.41l.11,1.59c0,.24.16.42.34.42s.32-.18.34-.42l.1-1.59c0-.37-.18-.41-.44-.41Zm0,0",
    transform: "translate(194.21 123)",
    fill: "#82afff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M.39-46.08A1.82,1.82,0,0,0-1-45.7s-.23-.9.94-1.12.46.74.46.74Zm0,0",
    transform: "translate(194.21 123)",
    fill: "#82afff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-.51-47.22a1.87,1.87,0,0,0-1.41-.33s.22-.9,1.35-.54.06.87.06.87Zm0,0",
    transform: "translate(194.21 123)",
    fill: "#82afff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M0-46.75a2.16,2.16,0,0,0-1.53.37s-.25-.89,1-1.11.5.74.5.74Zm0,0",
    transform: "translate(194.21 123)",
    fill: "#82afff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M14.13-44.36a1.83,1.83,0,0,0-1.27.69s-.43-.83.66-1.31.61.62.61.62Zm0,0",
    transform: "translate(194.21 123)",
    fill: "#82afff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M13-45.34a1.88,1.88,0,0,0-1.45,0s0-.93,1.2-.83.25.83.25.83Zm0,0",
    transform: "translate(194.21 123)",
    fill: "#82afff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M13.58-44.93a2.22,2.22,0,0,0-1.4.73s-.45-.82.74-1.33.66.6.66.6Zm0,0",
    transform: "translate(194.21 123)",
    fill: "#82afff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M22.82-43.9s-.29,0-.8.48c0,0-.36-.82.71-1.21s.09.73.09.73Zm0,0",
    transform: "translate(194.21 123)",
    fill: "#82afff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M22.27-45a1.8,1.8,0,0,0-1.39-.07s.06-.89,1.2-.74.19.81.19.81Zm0,0",
    transform: "translate(194.21 123)",
    fill: "#82afff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M22.78-44.58A2.09,2.09,0,0,0,21.4-44s-.39-.81.79-1.23.59.62.59.62Zm0,0",
    transform: "translate(194.21 123)",
    fill: "#82afff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-.86-51.73a2.06,2.06,0,0,0-1.56-.21s.15-1,1.42-.71.14.92.14.92Zm0,0",
    transform: "translate(194.21 123)",
    fill: "#82afff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-.92-53.44a1.83,1.83,0,0,0-1.39-.76,1.14,1.14,0,0,1,1.69-.21c1.08.71-.3,1-.3,1Zm0,0",
    transform: "translate(194.21 123)",
    fill: "#82afff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-.91-52.53a2.32,2.32,0,0,0-1.69-.34s.22-1,1.58-.66.11,1,.11,1Zm0,0",
    transform: "translate(194.21 123)",
    fill: "#82afff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M20.62-49.4c1.2,0,2.64-.44,2.86-1.69.27-1.43-1-2.16-2.61-2.09-1.2,0-4.25.74-6.42.66s-2.22-2.21,1.05-2c4.84.33,5.61-.29,5.61-.29-2.6.48-3.64-.43-6.41-.43s-3.29,1.91-2.17,3,5.78.39,7,.16,2.73-.24,2.85.61-1.91.72-3.34.67c-2.27-.09-5.58.52-8.52.67-2.45.13-2.79-.56-3.35-1.27a1.55,1.55,0,0,0,.2-.77,1.4,1.4,0,0,0-.06-.41,2,2,0,0,0,.47-1.06,2,2,0,0,0-1.1.13A2.31,2.31,0,0,0,5.23-54a2.33,2.33,0,0,0-1.44.48,2,2,0,0,0-1.1-.13,2.1,2.1,0,0,0,.47,1.06,1.4,1.4,0,0,0-.06.41,1.69,1.69,0,0,0,.65,1.3,1.08,1.08,0,0,1,.37.61l.07.35a.53.53,0,0,0,.26.34A4.59,4.59,0,0,1,1-51.77c-.55-.8-.9-2.56-1.74-2.75l-.5,2.65a7.89,7.89,0,0,0,3.05,3.48A27.74,27.74,0,0,0,5.2-46.9c.09.4-1.39.63-2.89.33-1-.21-2.45-1.73-3.25-1.62L0-46.11a8.87,8.87,0,0,0,6.65,1.3,2.41,2.41,0,0,0,1.94-1.8c.55-.11,1.15-.22,3-.68a14.54,14.54,0,0,1,2.56-.33c.25.57.82,1.31,2.79,1.37,0,0,.48.76-1.14.61s-2.05-.66-3-.55l.85,2a12,12,0,0,1,4.64-.46.72.72,0,0,0,.76-.28c.28-.41.15-.65-.11-1a4.19,4.19,0,0,1-.28-1.43c.94.24,3.82-.35,4.85-.26a1.23,1.23,0,0,1,.95,1.71c-.23.41-2.41.06-2.41.06l.73,2a4.31,4.31,0,0,0,.78-.63c.45-.43,2.29-.28,2.29-.6v-3.71a.29.29,0,0,0-.32-.29c-4.07.35-4.91-.33-4.91-.33Zm0,0",
    transform: "translate(194.21 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M4.38-50.72a1.28,1.28,0,0,1,.13.39l.06.35a.24.24,0,0,0,.23.21h1A.24.24,0,0,0,6-50L6-50.33a1.27,1.27,0,0,1,.12-.39Zm0,0",
    transform: "translate(194.21 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M5.27-50c-.22,0-.38,0-.36.33L5-48.41c0,.2.13.35.27.35s.26-.15.28-.35l.09-1.29c0-.3-.15-.33-.37-.33Zm0,0",
    transform: "translate(194.21 123)",
    fill: "#82afff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M3.21-33.62a1.39,1.39,0,0,0-1,.29s-.17-.68.7-.84.34.55.34.55Zm0,0",
    transform: "translate(194.21 123)",
    fill: "#82afff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M2.54-34.47a1.42,1.42,0,0,0-1.06-.25s.17-.67,1-.4,0,.65,0,.65Zm0,0",
    transform: "translate(194.21 123)",
    fill: "#82afff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M2.91-34.12a1.63,1.63,0,0,0-1.15.28s-.19-.67.77-.83.38.55.38.55Zm0,0",
    transform: "translate(194.21 123)",
    fill: "#82afff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M13.5-32.33a1.35,1.35,0,0,0-.95.52s-.32-.62.49-1,.46.46.46.46Zm0,0",
    transform: "translate(194.21 123)",
    fill: "#82afff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.67-33.07a1.4,1.4,0,0,0-1.08,0s0-.69.89-.63.19.62.19.62Zm0,0",
    transform: "translate(194.21 123)",
    fill: "#82afff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M13.09-32.75a1.65,1.65,0,0,0-1.05.54s-.34-.61.56-1,.49.45.49.45Zm0,0",
    transform: "translate(194.21 123)",
    fill: "#82afff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M20-32s-.22,0-.6.36c0,0-.27-.61.53-.91S20-32,20-32Zm0,0",
    transform: "translate(194.21 123)",
    fill: "#82afff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M19.6-32.82a1.34,1.34,0,0,0-1.05-.06s.05-.66.9-.55.15.61.15.61Zm0,0",
    transform: "translate(194.21 123)",
    fill: "#82afff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M20-32.49A1.55,1.55,0,0,0,19-32s-.29-.61.59-.92.44.46.44.46Zm0,0",
    transform: "translate(194.21 123)",
    fill: "#82afff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M2.28-37.84A1.54,1.54,0,0,0,1.11-38s.12-.75,1.06-.54.11.7.11.7Zm0,0",
    transform: "translate(194.21 123)",
    fill: "#82afff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M2.23-39.12a1.36,1.36,0,0,0-1-.57.86.86,0,0,1,1.27-.17c.81.54-.23.74-.23.74Zm0,0",
    transform: "translate(194.21 123)",
    fill: "#82afff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M2.24-38.44A1.72,1.72,0,0,0,1-38.7s.16-.78,1.18-.49.08.75.08.75Zm0,0",
    transform: "translate(194.21 123)",
    fill: "#82afff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M18.36-36.1c.91,0,2-.33,2.14-1.27s-.72-1.61-1.95-1.56a47.09,47.09,0,0,1-4.81.49c-1.62-.06-1.66-1.65.79-1.48,3.62.25,4.2-.22,4.2-.22-1.95.36-2.73-.32-4.8-.32S11.47-39,12.3-38.24s4.34.29,5.23.12,2-.18,2.14.45-1.43.54-2.5.5c-1.7-.07-4.17.4-6.38.51-1.83.09-2.09-.42-2.51-1a1.21,1.21,0,0,0,.16-.59,1,1,0,0,0,0-.3,1.53,1.53,0,0,0,.36-.79,1.61,1.61,0,0,0-.83.09,1.75,1.75,0,0,0-1.08-.36,1.74,1.74,0,0,0-1.07.36,1.61,1.61,0,0,0-.83-.09,1.53,1.53,0,0,0,.35.79,1.54,1.54,0,0,0,0,.3,1.26,1.26,0,0,0,.48,1,.8.8,0,0,1,.28.46l0,.26a.46.46,0,0,0,.19.26,3.46,3.46,0,0,1-2.59-1.64c-.42-.59-.68-1.91-1.31-2.06l-.37,2a5.85,5.85,0,0,0,2.29,2.6,21.35,21.35,0,0,0,2.54,1.12c.07.3-1,.47-2.15.25-.79-.16-1.84-1.3-2.44-1.22l.7,1.56a6.58,6.58,0,0,0,5,1A1.76,1.76,0,0,0,9.35-34c.42-.07.86-.16,2.25-.5a10.37,10.37,0,0,1,1.92-.25c.18.43.61,1,2.09,1,0,0,.35.57-.86.45s-1.53-.49-2.25-.41l.64,1.52a8.93,8.93,0,0,1,3.48-.34.54.54,0,0,0,.56-.22c.21-.3.12-.48-.08-.76a3.27,3.27,0,0,1-.21-1.07c.71.18,2.86-.26,3.64-.19a.92.92,0,0,1,.71,1.28c-.18.31-1.81,0-1.81,0L20-31.94a3.24,3.24,0,0,0,.58-.47c.34-.32,1.72-.21,1.72-.45v-2.78a.22.22,0,0,0-.25-.22c-3,.27-3.67-.24-3.67-.24Zm0,0",
    transform: "translate(194.21 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M6.2-37.09a1,1,0,0,1,.1.29l0,.26a.19.19,0,0,0,.18.16h.7a.18.18,0,0,0,.17-.16l.05-.26a1,1,0,0,1,.1-.29Zm0,0",
    transform: "translate(194.21 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M6.87-36.57c-.16,0-.29,0-.27.25l.06,1c0,.15.11.27.21.27s.2-.12.21-.27l.06-1c0-.24-.11-.25-.27-.25Zm0,0",
    transform: "translate(194.21 123)",
    fill: "#82afff"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "1",
    width: "409.6",
    height: "268.36",
    rx: "7",
    ry: "7",
    fill: "none"
  }));
};

var _default = FlagJE;
exports["default"] = _default;